/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import clsx from 'clsx';
import React from 'react';

import { Select } from '@atoms';

import s from './styles.module.less';

const TableSelect = ({
  /* ignore when spreading */ children,
  className,
  options,
  resetAfter,
  placeholder,
  value,
  ...props
}) => {
  return (
    <Select
      {...props}
      dropdownMatchSelectWidth={false}
      // well dumb but needs to have two ternary here
      // eslint-disable-next-line no-nested-ternary
      value={value !== undefined ? value : resetAfter ? '' : undefined}
      placeholder={placeholder}
      className={clsx(s.root, className, resetAfter && s.resetAfter)}
    >
      {resetAfter && (
        <Select.Option value="" style={{ display: 'none' }}>
          {placeholder}
        </Select.Option>
      )}

      {options.map(({ key, label, disabled }) => (
        <Select.Option key={key} value={key} disabled={disabled}>
          {label}
        </Select.Option>
      ))}
    </Select>
  );
};

export default TableSelect;
